import templateUrl from './transportation-provider-details.html';
import head from 'lodash/head';

export const transportationProviderDetailsComponent = {
	templateUrl,

	bindings: {
		details: '<'
	},

	controller: class TransportationProviderDetailsComponent {
		constructor(DateService, ApiService, TransportationProvidersService) {
			'ngInject';

			this.apiService = ApiService;
			this.dateService = DateService;
			this.transportationProvidersService = TransportationProvidersService;
		}

		$onInit() {
			this.details = this.transportationProvidersService.getProviderDetailsById(this.details);
			this.details = head(this.details);
		}

		_getClass(type) {
			return type === 'Public Transit' ? 'publicType' : type === 'Private Transportation' ? 'privateType' : type === 'Paratransit' ? 'paraTransit' : type === 'Volunteer' ? 'volunteer' : type === 'Other' ? 'otherType' : 'noType';
		}

		_getImage(image) {
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '';
		}

		_getTime(time) {
			return this.dateService.getFormattedTime(time);
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-provider-details/transportation-provider-details.component.js